import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IResetPasswordStep1ReqBody, IResetPasswordStep1Entity } from '../../../entity';

export interface IResetPasswordStep1UseCase {
    execute(lang: string, reqBody: IResetPasswordStep1ReqBody): Promise<IResetPasswordStep1Entity>;
}

export class ResetPasswordStep1UseCase implements IResetPasswordStep1UseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(lang: string, reqBody: IResetPasswordStep1ReqBody): Promise<IResetPasswordStep1Entity> {
        return await this.userRepo.resetPasswordStep1(lang, reqBody);
    }
}
